import { request as __request } from '../core/request.js';
export class WebhookRequestService {
    /**
     * Webhook request
     * @param requestBody
     * @returns any The events have been successfully handled. Any status code of the `2xx` format has the same behaviour. Any header or body are ignored by Lune.
     */
    webhookRequest(requestBody) {
        return __request(this.client, this.config, {
            method: 'POST',
            url: '/WebhookRequest',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
//# sourceMappingURL=WebhookRequestService.js.map